import { url as brandsURL } from '../index';
import ApiService from '@api/api-service';

export const url = `${brandsURL}`;
export default new ApiService(url);
